import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@themesberg/react-bootstrap";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const notHaveResultYet = (
  <td className="text-warning text-center">{"Chưa có kết quả"}</td>
);

const cannotGetResult = (
  <td className="text-danger text-center">{"Không lấy được kết quả"}</td>
);

export const TableRow = (props) => {
  const {
    id,
    handleAddResult,
    resultDate,
    ClassicLotteryChannel,
    result,
    symbol,
    status,
    onCalculateRewardPress,
    totalInputAmount,   // nhập
    totalTickets,       // tổng vé bán
    totalRewaredTickets, // trúng thưởng
    totalUnRewardTickets, // không trúng thưởng
    totalRewaredUnmarketableTickets, // trúng thưởng ế
    totalUnRewardUnmarketableTickets, // không trúng thưởng ế
    totalUnmarketableTickets, // tổng vé ế
    region,
  } = props;

  const linkToStatistic = `/classic/statistic-by-ticket?resultId="${id}"&region="${region || ''}"`;
  const linkToUnmarketableTicket = `/classic/statistic-by-unmarketable-ticket?resultId="${id}"&region="${region || ''}"`;

  const [statusState, setStatusState] = useState(status);

  const [resultData, setResultData] = useState(result);
  const [symbolData, setSymbolData] = useState(symbol || '');

  // Keep row in sync when parent patches list (e.g. after calculate reward → status 4 on server)
  useEffect(() => {
    setStatusState((prev) => (status > prev ? status : prev));
  }, [status]);

  const updateNewResult = useCallback(
    (newResult, newSymbol) => {
      setResultData(newResult);
      if (typeof newSymbol === 'string') {
        setSymbolData(newSymbol);
      }
      if (statusState < 3) {
        setStatusState(3);
      }
    },
    [statusState],
  );

  const viewResult = (
    <td className="text-center">
      <Button
        variant="info"
        onClick={() =>
          handleAddResult(id, resultData, updateNewResult, false, symbolData)
        }
      >
        Xem kết quả
      </Button>
    </td>
  );

  const resultTd = useMemo(() => {
    let _resultTd = notHaveResultYet;

    if (statusState === 3 || statusState === 4 || statusState === 5) {
      if (resultData && resultData.length > 0) {
        _resultTd = viewResult;
      } else {
        _resultTd = cannotGetResult;
      }
    }

    return _resultTd;
  }, [statusState, resultData, viewResult]);

  const statisticTd = useMemo(() => {
    const rewarded = totalRewaredTickets || 0;
    const unrewarded = totalUnRewardTickets || 0;
    const totalProcessed = rewarded + unrewarded;
    const umRewarded = totalRewaredUnmarketableTickets || 0;
    const umUnrewarded = totalUnRewardUnmarketableTickets || 0;
    const totalUm = umRewarded + umUnrewarded;

    if (statusState < 3) {
      return <td className="text-center text-muted">—</td>;
    }
    if (totalProcessed === 0 && totalUm === 0) {
      return <td className="text-center text-muted">Chưa tính thưởng</td>;
    }
    return (
      <td className="text-center">
        {totalProcessed > 0 && (
          <>
            <b>Tổng vé bán: </b>
            <b className="text-info">{totalProcessed}</b>
            <br />
            Trúng thưởng: <b className="text-success">{rewarded}</b>
            <br />
            Không trúng thưởng: <b className="text-danger">{unrewarded}</b>
            {totalUm > 0 && <br />}
          </>
        )}
        {totalUm > 0 && (
          <>
            <b>Tổng vé ế: </b>
            <b className="text-info">{totalUm}</b>
            <br />
            Trúng thưởng: <b className="text-success">{umRewarded}</b>
            <br />
            Không trúng thưởng: <b className="text-danger">{umUnrewarded}</b>
          </>
        )}
      </td>
    );
  }, [
    statusState,
    totalRewaredTickets,
    totalUnRewardTickets,
    totalRewaredUnmarketableTickets,
    totalUnRewardUnmarketableTickets,
  ]);

  let inputAmount = totalInputAmount || 0;

  const actionTd = useMemo(() => {
    const totalProcessed =
      (totalRewaredTickets || 0) + (totalUnRewardTickets || 0);
    const totalUm =
      (totalRewaredUnmarketableTickets || 0) +
      (totalUnRewardUnmarketableTickets || 0);
    const uncompletedTickets =
      (totalInputAmount || 0) - (totalTickets || 0) - (totalUnmarketableTickets || 0);
    const uncalculatedTickets =
      (totalTickets || 0) +
      (totalUnmarketableTickets || 0) -
      (totalRewaredTickets || 0) -
      (totalUnRewardTickets || 0) -
      (totalRewaredUnmarketableTickets || 0) -
      (totalUnRewardUnmarketableTickets || 0);
    const showUncompletedWarning = inputAmount > 0 && uncompletedTickets > 0;
    const showCalculateButton =
      inputAmount > 0 && !showUncompletedWarning && uncalculatedTickets > 0;
    const showViewButtons =
      inputAmount > 0 && !showUncompletedWarning && !showCalculateButton;

    switch (statusState) {
      case 2:
        return "Đang chờ kết quả";
      case 3:
      case 4:
      case 5:
        if (inputAmount === 0) {
          return "Không kinh doanh";
        }
        if (showUncompletedWarning) {
          return (
            <>
              Vé chưa hoàn thành: <b className="text-warning">{uncompletedTickets}</b>
              <br />
              <span className="text-warning">
                Chưa hoàn thành đủ vé, hãy kiểm tra lại
              </span>
              <br />
            </>
          );
        }
        if (showCalculateButton) {
          return (
            <>
              Vé chưa tính thưởng: <b className="text-warning">{uncalculatedTickets}</b>
              <br />
              <Button
                variant="danger"
                className="m-1"
                onClick={() => onCalculateRewardPress(id)}
              >
                Tính thưởng
              </Button>
            </>
          );
        }
        if (showViewButtons) {
          return (
            <>
              {totalProcessed > 0 && (
                <Button variant="warning" className="m-1">
                  <Link
                    target={"_blank"}
                    style={{ color: "#fff" }}
                    to={linkToStatistic}
                    key={id}
                  >
                    {"Xem vé bán"}
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
                  </Link>
                </Button>
              )}
              {totalUm > 0 && (
                <Button variant="primary" className="m-1">
                  <Link
                    target={"_blank"}
                    style={{ color: "#fff" }}
                    to={linkToUnmarketableTicket}
                    key={id}
                  >
                    {"Xem vé ế"}
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
                  </Link>
                </Button>
              )}
            </>
          );
        }
        return "";
      default:
        return "";
    }
  }, [
    statusState,
    id,
    inputAmount,
    linkToStatistic,
    linkToUnmarketableTicket,
    onCalculateRewardPress,
    totalRewaredTickets,
    totalRewaredUnmarketableTickets,
    totalTickets,
    totalInputAmount,
    totalUnmarketableTickets,
    totalUnRewardTickets,
    totalUnRewardUnmarketableTickets,
  ]);

  return (
    <tr>
      <td className="text-center">{actionTd}</td>
      <td className="text-center">
        {ClassicLotteryChannel.name}
        <br />
        {resultDate}
      </td>
      {resultTd}
      {statisticTd}
      {inputAmount === 0 && <td colSpan={3} className="text-center"></td>}
      {inputAmount > 0 && (
        <>
          <td className="text-center">{inputAmount}</td>
          <td className="text-center">{totalTickets}</td>
          <td className="text-center">
            <strong>{totalUnmarketableTickets}</strong>
          </td>
        </>
      )}
    </tr>
  );
};
